var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOptionsEditProfile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "6px",
    viewBox: "0 0 28 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icOptionsEditProfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.75,5.5 C1.36928813,5.5 0.25,4.38071187 0.25,3 C0.25,1.61928813 1.36928813,0.5 2.75,0.5 C4.13071187,0.5 5.25,1.61928813 5.25,3 C5.25,4.38071187 4.13071187,5.5 2.75,5.5 Z M14,5.5 C12.6192881,5.5 11.5,4.38071187 11.5,3 C11.5,1.61928813 12.6192881,0.5 14,0.5 C15.3807119,0.5 16.5,1.61928813 16.5,3 C16.5,4.38071187 15.3807119,5.5 14,5.5 Z M25.25,5.5 C23.8692881,5.5 22.75,4.38071187 22.75,3 C22.75,1.61928813 23.8692881,0.5 25.25,0.5 C26.6307119,0.5 27.75,1.61928813 27.75,3 C27.75,4.38071187 26.6307119,5.5 25.25,5.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icOptionsEditProfile",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOptionsEditProfile);
export default __webpack_public_path__ + "static/media/icOptionsEditProfile.d651396c7326ed6fa2d4347f4ccf88b7.svg";
export { ForwardRef as ReactComponent };